/**
 * Types of entity which can be treated as contacts
 */
export enum CONTACT_TYPE {
  JOBSITE = 'jobsite',
  CUSTOMER = 'customer',
}

export type ContactsTypesTypes = CONTACT_TYPE.JOBSITE | CONTACT_TYPE.CUSTOMER;
